import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, filter, mergeMap } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { ConnectionService } from '../../services/connection-service';

@Component({
    selector: 'search-support-question', templateUrl: './search-support-question.html',
    standalone: false
})
export class SearchSupportQuestionComponent {
  autoCompleteController: UntypedFormControl = new UntypedFormControl();
  options: Observable<Array<{ name: string; object: any }>>;
  image: string = '';
  excludeIds: Array<string>;

  constructor(private conn: ConnectionService, private dialogRef: MatDialogRef<SearchSupportQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.autoCompleteController.setValue('');
    this.excludeIds = this.data.excludeIds;
    this.options = this.autoCompleteController.valueChanges.pipe(
      debounceTime(300),
      filter((token: string) => !!token.length),
      mergeMap((token: string) => this.getSupportQuestions(token)));
  }

  async getSupportQuestions(name: string): Promise<any> {
    return this.conn.getSupportQuestions({
      where: {
        question: { $regex: name, $options: 'i' },
        objectId: { $nin: this.excludeIds },
      },
      limit: 10,
    })
      .then((supportQuestions: any) => supportQuestions
        .map((object: any) => ({ name: object.get('question'), object })));
  }

  hideModal(data: any): void {
    this.dialogRef.close(data);
  }

  autoCompleteOnSelect(item: { name: string, object: any }): void {
    this.hideModal(item.object);
  }
}
